<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <v-row>
    <v-col cols="12" md="7" order="2" order-md="1">
      <food-chart-card :diaryDate="pickerDate">
        <template v-slot:foodbody>
          <v-data-table
          :headers="groupedHeader"
          :items="foodEntries"
          group-key="m"
          group-by="m"
          mobile-breakpoint="400"
          :footer-props="{
            'items-per-page-options': [10, 20, 50, 100]
          }"
          :items-per-page="100"
        >

          <template v-slot:group="props">
            <div class="card-title primary white--text pl-3 py-1">{{ mealName(props.group) }} </div>

            <v-data-table
              :headers="headers"
              :items="props.items"
              item-key="n"
              hide-default-footer
              mobile-breakpoint="400"
              :show-expand="!isMobile"
            >

        <template v-slot:item.data-table-expand="{ expand, isExpanded }">
          <v-icon @click="expand(!isExpanded)" v-if="!isExpanded && !isMobile" class="grey--text mr-2">mdi-eye</v-icon>
          <v-icon @click="expand(!isExpanded)" v-if="isExpanded && !isMobile" class="grey--text mr-2">mdi-eye-off</v-icon>
        </template>
            <template v-slot:item.c="{ item }">
            <v-chip
              label outlined small pill
              :class="choiceClass(item.c)"
              :text-color="choiceClass(item.c)"
              v-text="choiceText(item.c)"
            >
            </v-chip>
          </template>
          
        <template v-slot:item.actions="{ item }">
            <v-icon small @click="confirmDelete(item)">mdi-delete</v-icon>
          </template>
          <template v-slot:item.n="{ item }">
            {{ item.n }} ({{ item.q }} {{ item.u }})
          </template>
            <template v-slot:expanded-item="{ item, headers }">
              <td :colspan="headers.length">
               
                <div class="display-1 text-center secondary white--text py-1">Portion Details</div>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="title text-uppercase text-center">Portion</th>
                        <th class="title text-uppercase text-center" v-for="groupName in groupNames" :key="groupName">{{ groupName }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-center">{{ item.p }} {{ item.u }}</td>
                        <td v-for="groupName in groupNames" :key="groupName" class="text-center">{{ groupUsage(item, groupName).p || '--' }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>


                <div class="display-1 text-center secondary white--text py-1">Used for this entry</div>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="title text-uppercase text-center">Used</th>
                        <th class="title text-uppercase text-center" v-for="groupName in groupNames" :key="groupName">{{ groupName }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-center">{{ item.q }} {{ item.u }}</td>
                        <td v-for="groupName in groupNames" :key="groupName" class="text-center">{{ (groupUsage(item, groupName).p) * (item.q/item.p) || '--' }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </td>
            </template>
            </v-data-table>
          </template>

          <template v-slot:item.c="{ item }">
            <v-chip
              label outlined small pill
              :class="choiceClass(item.c)"
              :text-color="choiceClass(item.c)"
              v-text="choiceText(item.c)"
            >
            </v-chip>
          </template>
          <template v-slot:item.q="{ item }">
            {{ item.q }} {{ item.u }}
          </template>
        </v-data-table>
        </template>
      </food-chart-card>
    </v-col>
    
  <v-col cols="12" md=5 order="1" order-md="2">
    <v-date-picker 
      v-model="pickerDate" 
      :events="foodDates" 
      full-width
      event-color="secondary" 
      color="primary" 
      class="sticky"
      :update:picker-date="dateChanged"
    >
    <v-spacer />
      <v-btn color="primary" :to="{name: 'Add Food'}">
        Log Food 
      </v-btn>
    <v-spacer />
      </v-date-picker>
  </v-col>
    </v-row>

    <!-- DIALOGS -->
    <v-dialog v-model="showConfirmDelete" max-width="300">
      <v-card>
        <v-card-title>
          <span>Are you sure?</span>
          <v-spacer />
          <v-icon aria-label="Close" @click="showConfirmDelete=false">mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text class="pb-6 pt-12 text-center">
          Would you like to delete this entry '{{ selectedFood.n }} ({{ selectedFood.q }} {{ selectedFood.u }})'?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mr-3" text  @click="showConfirmDelete=false">
            No
          </v-btn>
          <v-btn  color="error" text @click="deleteFoodConfirmed()" :loading="deletingFood">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import moment from 'moment'
import foodChartCard from '@/views/dashboard/component/FoodChartCard'

  export default {
    components: {
      foodChartCard,
    },
    name: 'food-diary',
    data () {
      return {
        isMobile: false,
        selectedFood: {},
        showConfirmDelete: false,
        deletingFood: false,
        pickerDate: undefined,
        groupedHeader: [
          {
            text: 'Food',
            align: 'start',
            value: 'n',
          }
        ],
        headers: [
          { 
            text: '', value: 'data-table-expand' 
          },
          {
            text: 'Description',
            align: 'start',
            value: 'n',
          },
          { 
            text: 'Choice', 
            value: 'c',
            align: 'end', 
            },
          { 
            text: '', 
            value: 'actions',
            align: 'end',
          },
        ],
      }
    },
    watch: {
      pickerDate(val) {
        this.setActivedate(val)
      }
    },
    computed: {
      ...mapState('Diary', ['foodDiary', 'deletingWeight', 'deletingWeightError', 'activeDate']),
      ...mapState('Profile', ['profile']),
      ...mapGetters('Diary', ['foodAllowancesUsed', 'foodDates', 'foodEntries']),
      groupNames() {
        return this.foodAllowancesUsed.map(p => p.n);
      },
    },

    methods: {
      ...mapActions('Diary', ['deleteWeight', 'deleteFood']),
      ...mapMutations('Ui', ['showSnackbar', 'setFoodAddModal']),
      ...mapMutations('Diary', ['setActivedate']),
      confirmDelete(weight){
        this.selectedFood = weight;
        this.showConfirmDelete = true;
      },
      dateChanged() {
      },
      deleteFoodConfirmed() {
        this.deletingFood = true;
        this.deleteFood(this.selectedFood)
        .then(() => {
          // success
          this.showConfirmDelete=false;
          this.showSnackbar({
            snackbarType: 'success',
            snackbarMessage: 'Entry was deleted successfully',
          });
        })
        .catch(() => {
          // error
          this.showSnackbar({
            snackbarType: 'error',
            snackbarMessage: 'There was an error deleteing the entry.  Please try again.',
          });
        })
        .finally(() => this.deletingFood = false)
      },
      groupUsage(item, groupName) {
        return item.g.find(p => p.n == groupName) ?? {  };
      },
      choiceClass: function(fieldVal) {
        switch (fieldVal) {
          case 1: return 'green'
          case 2: return 'orange'
          case 3: return 'gray'
          case 4: return 'red'
        }
        return 'white';
      },
      choiceText: function(fieldVal) {
        switch (fieldVal) {
          case 1: return 'best'
          case 2: return 'better'
          case 3: return 'breakout'
          case 4: return 'good'
        }
        return 'white';
      },
      mealName: function(fieldVal) {
        switch (fieldVal) {
          case 0: return 'Breakfast'
          case 1: return 'Lunch'
          case 2: return 'Dinner'
          case 3: return 'Snack'
        }
        return 'white';
      },
      onResize () {
        this.isMobile = window.innerWidth < 600
      },
    },
    mounted: function() {     
      this.onResize()
      window.addEventListener('resize', this.onResize, { passive: true })
      // HACK: Add 4 hours to get around the day decreasing with every visit (GMT etc.) - FIX using GMT instead of local time
      this.pickerDate = (this.activeDate ? moment(this.activeDate).add(4, 'hour') : moment()).toISOString().substr(0, 10)
    },
    beforeDestroy () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, { passive: true })
      }
    },
  }
</script>
<style >
.sticky {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 75px;
}
</style>